import React from "react";
import { Form } from "@redriver/cinnamon";
import { getUsers } from "./actions";

const UsersTypeAhead = (props) => (
  <Form.TypeAhead {...props} lookupAction={getUsers} />
);

export default UsersTypeAhead;
